var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitsLotsDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.943,
    height: 19.825,
    viewBox: "0 0 22.943 19.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "units-lots-details",
    transform: "translate(-309 -916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_visibility_24px",
    d: "M7.471,4.5A6.958,6.958,0,0,0,1,8.912a6.952,6.952,0,0,0,12.943,0A6.958,6.958,0,0,0,7.471,4.5Zm0,7.354a2.942,2.942,0,1,1,2.942-2.942A2.943,2.943,0,0,1,7.471,11.854Zm0-4.706A1.765,1.765,0,1,0,9.236,8.912,1.763,1.763,0,0,0,7.471,7.147Z",
    transform: "translate(318 922.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_queue_music_24px",
    d: "M15,6H3V8H15Zm0,4H3v2H15ZM3,16H6.538V14H3Z",
    transform: "translate(309 914)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_open_in_new_24px",
    d: "M16,2H2V16H9v2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H16a2.006,2.006,0,0,1,2,2V9H16Z",
    transform: "translate(309 916)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitsLotsDetails);
export default __webpack_public_path__ + "static/media/units-lots-details.a25eaa185daec6b1cb5bebf54bc55a97.svg";
export { ForwardRef as ReactComponent };